import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = 'https://aadhavacademy.com/api/session/session.php';
const BLOCKS_API = 'https://aadhavacademy.com/api/session/blocks.php';

// Thunks
export const fetchSessions = createAsyncThunk('sessions/fetchSessions', async ({ search = '', page = 1, limit = 5 }) => {
  const response = await axios.get(API_URL, { params: { search, page, limit } });
  return response.data;
});

export const fetchBlocks = createAsyncThunk('sessions/fetchBlocks', async () => {
  const response = await axios.get(BLOCKS_API);
  return response.data;
});

export const addSession = createAsyncThunk('sessions/addSession', async (sessionData) => {
  const response = await axios.post(API_URL, sessionData);
  return response.data;
});

export const updateSession = createAsyncThunk('sessions/updateSession', async ({ id, sessionData }) => {
  const response = await axios.put(`${API_URL}?id=${id}`, sessionData);
  return response.data;
});

export const deleteSession = createAsyncThunk('sessions/deleteSession', async (id) => {
  const response = await axios.delete(`${API_URL}?id=${id}`);
  return response.data;
});

const sessionSlice = createSlice({
  name: 'sessions',
  initialState: {
    sessions: [],
    total: 0,
    totalPages: 0,
    currentPage: 1,
    loading: false,
    error: null,
    selectedSession: null,
    blocks: [],  // store blocks
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setSelectedSession: (state, action) => {
      state.selectedSession = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Sessions fetch
      .addCase(fetchSessions.pending, (state) => { state.loading = true; })
      .addCase(fetchSessions.fulfilled, (state, action) => {
        state.sessions = action.payload.sessions || [];
        state.total = action.payload.total || 0;
        state.totalPages = action.payload.totalPages || 0;
        state.currentPage = action.payload.currentPage || 1;
        state.loading = false;
      })
      .addCase(fetchSessions.rejected, (state, action) => { state.error = action.error.message; state.loading = false; })

      // Blocks fetch
      .addCase(fetchBlocks.pending, (state) => { state.loading = true; })
      .addCase(fetchBlocks.fulfilled, (state, action) => { state.blocks = action.payload || []; state.loading = false; })
      .addCase(fetchBlocks.rejected, (state, action) => { state.error = action.error.message; state.loading = false; })

      // Add Session
      .addCase(addSession.fulfilled, (state, action) => { state.sessions.unshift(action.payload); })
      
      // Update Session
      .addCase(updateSession.fulfilled, (state, action) => {
        const updated = action.payload;
        state.sessions = state.sessions.map(sess => sess.id === updated.id ? updated : sess);
      })
      
      // Delete Session
      .addCase(deleteSession.fulfilled, (state, action) => {
        state.sessions = state.sessions.filter(sess => sess.id !== action.payload.id);
      });
  },
});

export const { setCurrentPage, setSelectedSession } = sessionSlice.actions;
export const selectBlocks = (state) => state.sessions.blocks;
export default sessionSlice.reducer;
